<template lang="pug">
select.form-control.c-select(
    :class="className",
    @change="selectTag",
    key="tag-selector"
)
    option(
        :value="null",
        :selected="null == value"
    ) {{ placeholder }}
    
    option(
        v-for="tag in tags",
        :key="tag.id",
        :value="tag.id",
        :selected="tag.id == value"
    ) {{ tag.name }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        className: {
            type: String,
            default: '',
        },

        placeholder: {
            type: String,
            default: 'Filter Tag',
        },

        value: {
            type: Number,
            default: null,
        },

        excludeId: {
            type: Number,
            default: null,
        },
    },

    computed: {
        ...mapGetters('tag', ['tagList']),

        tags() {
            if (this.excludeId !== null)
                return this.tagList.filter(o => o.id != this.excludeId);

            return this.tagList;
        },
    },

    created() {
        if (!this.tagList.length) this.getTagList();
    },

    methods: {
        ...mapActions('tag', ['getTagList']),

        selectTag(e) {
            const value =
                e.target.value == null || e.target.value == 'null'
                    ? null
                    : parseInt(e.target.value);

            this.$emit('select', value);
            this.$emit('input', value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/tags-selector.vue